var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolidayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "beach_access_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HolidayIcon; Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M7.60001 7.59998C7.13001 9.93998 7.63001 12.38 8.99001 14.43L14.44 8.97998C12.91 7.95998 11.16 7.41998 9.36001 7.41998C8.76001 7.41998 8.17001 7.47998 7.60001 7.59998Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "HolidayIcon; Light Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    opacity: 0.5,
    d: "M13.12 5C12.19 5 11.3 5.16 10.45 5.46C12.36 5.65 14.24 6.35 15.89 7.53L17.28 6.14C16.03 5.4 14.61 5 13.12 5Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "HolidayIcon; Light Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    opacity: 0.5,
    d: "M5 13.12C5 14.61 5.4 16.03 6.14 17.27L7.53 15.88C6.35 14.23 5.65 12.36 5.46 10.44C5.16 11.3 5 12.2 5 13.12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "HolidayIcon; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M13.1257 14.5608L14.5541 13.1324L20.9958 19.5741L19.5674 21.0025L13.1257 14.5608Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "HolidayIcon; Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97995 5.95C7.95995 3.98 10.5399 3 13.1199 3C15.7099 3 18.2999 3.99 20.2699 5.96L5.96995 20.27C2.01995 16.32 2.01995 9.91 5.96995 5.96L5.97995 5.95ZM4.99995 13.12C4.99995 14.61 5.39995 16.03 6.13995 17.27L7.52995 15.89C6.34995 14.24 5.64995 12.36 5.45995 10.45C5.15995 11.3 4.99995 12.19 4.99995 13.12ZM8.97995 14.43C7.62995 12.38 7.11995 9.93 7.59995 7.6C8.17995 7.48 8.75995 7.42 9.34995 7.42C11.1499 7.42 12.8999 7.97 14.4299 8.98L8.97995 14.43ZM13.1199 5C12.1899 5 11.2999 5.16 10.4499 5.46C12.3599 5.65 14.2299 6.35 15.8799 7.53L17.2699 6.14C16.0299 5.4 14.6099 5 13.1199 5Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayIcon);
export default __webpack_public_path__ + "static/media/holidayIcon.c4e2929d8d7e269bca8d041c9e1f9c62.svg";
export { ForwardRef as ReactComponent };